import {PreReservation} from '../../../../_shared/model/preReservation.model';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import 'rxjs';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {HelperService} from '../../../../_shared/services';

@Injectable()
export class TermsService {
    data: any;
    token: any;

    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    public cancelReservation(prereservation: PreReservation): Observable<any> {
        return this.httpClient.post(this.helper.getApiUrl() + '/reservation/delete', prereservation);
    }

    public getReservation(contractorId: number, prereservationId: string): Observable<any> {
        return this.httpClient.get(
            this.helper.getApiUrl() + '/contractors/' + contractorId + '/reservations/' + prereservationId,
        );
    }

    public customerNoShow(prereservation: string, notShow: boolean): Observable<any> {
        const data: any = {
            noShow: notShow,
        };
        return this.httpClient.put(this.helper.getApiUrl() + '/reservations/' + prereservation, data);
    }
}
